export const BankReaderName = {
  TINK: "tink",
  EUROBITS: "eurobits",
};
